import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import * as actions from '../../../store/actions';

import {
  List, ListItem, ListSubheader, Divider, Collapse
} from '@mui/material';
import {
  DateRange, PlaylistAddCheck, Backup, Room, Build, Attachment, Settings, AccountCircle, Work, Business, ExpandLess, ExpandMore, Public, TodayRounded, MoreTimeRounded, Assignment, AccessTime, SettingsIcon, FileDownload, Construction, EditNote
} from '@mui/icons-material';

import DashboardIcon from '@mui/icons-material/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt'
import ListItemIcon from './ListItemIcon';
import ListItemText from './ListItemText';
import checkTenantFeatureFlag from '../../../utils/checkTenantFeatureFlag';
import { i18n } from '../../../translate/i18n';
import ListItemStyled from './ListItem';
import EFeatureFlags from '../../../utils/EFeatureFlags';
import { checkFeatureFlag } from '../../../utils/checkFeatureFlag';

const objListItems = [
  { type: 'area1', label: i18n.t('objectItems.label1'), urlParam: 'calendar', roles: ['analyst', 'contractor',], icon: <DateRange /> },
  { type: 'area1', label: i18n.t('objectItems.label20'), urlParam: 'expired-services', roles: ['analyst', 'contractor',], badge: true, icon: <AccessTime /> },
  { type: 'area1', label: i18n.t('objectItems.label2'), urlParam: 'actions', roles: ['analyst', 'contractor'], icon: <PlaylistAddCheck /> },
  { type: 'area1', label: i18n.t('objectItems.label22'), urlParam: 'scheduled-services-calendar', featureFlag: EFeatureFlags.SCHEDULED_SERVICES, roles: ['analyst', 'contractor'], icon: <TodayRounded /> },
  { type: 'area1', label: i18n.t('objectItems.label21'), urlParam: 'scheduled-services-planner', featureFlag: EFeatureFlags.SCHEDULED_SERVICES, roles: ['analyst', 'contractor'], icon: <MoreTimeRounded /> },
  { type: 'area1', label: i18n.t('objectItems.label19'), urlParam: 'maintenances', roles: ["analyst", "contractor"], tenantFeatureFlag: 'VIEW_MAINTENANCE', icon: <Build /> },
  { type: 'area1', label: i18n.t('objectItems.label3'), urlParam: 'admin-places', roles: ['analyst', 'contractor'], icon: <Room /> },
  { type: 'area1', label: i18n.t('objectItems.label4'), urlParam: 'admin-maps', roles: ['analyst', 'contractor'], icon: <Public /> },
  { type: 'area1', label: i18n.t('objectItems.label18'), urlParam: 'admin-reports', roles: [''], icon: <Assignment /> },
  { type: 'area1', label: 'PowerBi Dashboard', urlParam: 'powerbi', roles: ['analyst'], featureFlag: EFeatureFlags.POWER_BI_DASHBOARD, icon: <DashboardIcon /> },
  { type: 'area2', label: i18n.t('objectItems.label6'), urlParam: 'admin-gestao-equip', roles: ['analyst', 'contractor'], icon: <Work /> },
  { type: 'area2', label: i18n.t('objectItems.label7'), urlParam: 'admin-gestao-servicos', roles: ['analyst', 'contractor'], icon: <Build /> },
  { type: 'area2', label: i18n.t('objectItems.serviceDrafts'), urlParam: 'service-drafts', roles: ['analyst', 'contractor'], icon: <EditNote /> },
  { type: 'area2', label: i18n.t('objectItems.label8'), urlParam: 'admin-empresas', roles: ['analyst'], icon: <Business /> },
  { type: 'area2', label: 'Logs', urlParam: 'admin-logs', roles: ['admin'], icon: <ListAltIcon /> },
  { type: 'area2', label: i18n.t('objectItems.label24'), urlParam: 'data-export', roles: ['admin', 'analyst'], icon: <FileDownload /> },
  { type: 'params', label: i18n.t('objectItems.label9'), urlParam: 'admin-usuarios', roles: [''] },
  { type: 'params', label: i18n.t('objectItems.label10'), urlParam: 'admin-areas', roles: [''] },
  { type: 'params', label: i18n.t('objectItems.label12'), urlParam: 'admin-groups', roles: [''] },
  { type: 'params', label: i18n.t('objectItems.label14'), urlParam: 'admin-tipos-servicos', roles: [''] },
  { type: 'params', label: i18n.t('objectItems.label13'), urlParam: 'admin-period', roles: [''] },
  { type: 'params', label: i18n.t('objectItems.label11'), urlParam: 'admin-equipments', roles: [''] },
  { type: 'params', label: 'Webhook', urlParam: 'admin-notification-webhook', roles: [''], featureFlag: EFeatureFlags.NOTIFICATIONS_WEBHOOKS},
  { type: 'area4', label: i18n.t('objectItems.label16'), urlParam: 'arquivo-apoio', roles: ['analyst', 'doorman', 'contractor'], icon: <Attachment /> },
  { type: 'area4', label: i18n.t('objectItems.label15'), urlParam: 'minha-conta', roles: ['analyst', 'doorman', 'contractor'], icon: <AccountCircle /> },
  { type: 'system', label: i18n.t('objectItems.label23'), urlParam: 'settings', roles: ['admin'], icon: <Settings /> }
]

const backupsItem =    { type: 'area2', label: i18n.t('objectItems.label17'), urlParam: 'admin-backups-app', roles: ['admin'], icon: <Backup /> };

const styles = {
  color: 'darkgreen',
  icon: {
    size: 'small',
  },
  header: {
    fontSize: '0.85rem',
  },
  badge: {
    width: '160px',
  },
}

const NavLinkStyled = styled(NavLink)`
  color: #333;
  text-decoration: none;
`

const ListItems = () => {
  const [openParam, setOpenParam] = useState(true);
  const [selected, setSelected] = useState({});
  const dispatch = useDispatch();
  const expiredServicesBadge = useSelector(state => state.expiredServices.badge);

  const selectItem = urlParam => {
    if (urlParam === 'admin-gestao-servicos') {
      clearSelectedServices();
    }
    setSelected(urlParam);
    clearFilters();
  }

  const tenantFeatureFlags = useSelector(state => state.auth.selectedAccess.tenant.tenantFeatureFlags);
  const featureFlags = useSelector(state => state.auth.selectedAccess.tenant.featureFlags);
  const role = useSelector(state => state.auth.selectedAccess.role);
  const superadmin = useSelector(state => state.auth.superadmin);

  const clearFilters = () => {
    dispatch(actions.clearCalendarsState());
  };

  const clearSelectedServices = () => {
    dispatch(actions.clearServicesSelected());
  };

  return (
    <>
      <List
        subheader={<ListSubheader component="div" id="nested-list-subheader1" style={{ backgroundColor: 'white' }}>{i18n.t('render.listLabel1')}</ListSubheader>
        }>
        {
          
             objListItems.filter(listItem => {
                return listItem.type === 'area1' &&
                  (listItem.roles.indexOf(role) > -1 || role === 'admin') &&
                  (!listItem.tenantFeatureFlag || checkTenantFeatureFlag(listItem.tenantFeatureFlag, tenantFeatureFlags)) &&
                  (!listItem.featureFlag || checkFeatureFlag({featureFlagToCheck: listItem.featureFlag, featureFlags}))
              }
            ).map((listItem, ind) => (
              <ListItemStyled
                key={listItem.label}
                label={listItem.label}
                url={listItem.urlParam}
                icon={listItem.icon}
                selected={selected === listItem.urlParam}
                handleClickItem={() => selectItem(listItem.urlParam)}
                badge={listItem.badge ? expiredServicesBadge : false}
              />
            ))
        }
      </List>
      <Divider />
      <List
        subheader={<ListSubheader component="div" id="nested-list-subheader2" style={{ backgroundColor: 'white' }}>{i18n.t('render.listLabel2')}</ListSubheader>
        }>
        {
          <>
            {objListItems.filter(key => key.type === 'area2' && (key.roles.indexOf(role) > -1 || role === 'admin') && (!key.tenantFeatureFlag || checkTenantFeatureFlag(key.tenantFeatureFlag, tenantFeatureFlags))).map(key => (
              <NavLinkStyled to={"/" + key.urlParam} key={key.label}>
                <ListItem
                  style={{ backgroundColor: selected === key.urlParam && 'rgba(0,0,0,.05)' }}
                  button
                  onClick={() => selectItem(key.urlParam)}>
                  <ListItemIcon icon={key.icon} color={selected === key.urlParam && styles.color} />
                  <ListItemText label={key.label} color={selected === key.urlParam && styles.color} />
                </ListItem>
              </NavLinkStyled>
            ))}
            { superadmin &&
              <NavLinkStyled to={backupsItem.urlParam}>
                <ListItem
                  style={{ backgroundColor: selected === backupsItem.urlParam && 'rgba(0,0,0,.05)' }}
                  button
                  onClick={() => selectItem(backupsItem.urlParam)}>
                  <ListItemIcon icon={backupsItem.icon} color={selected === backupsItem.urlParam && styles.color} />
                  <ListItemText label={backupsItem.label} color={selected === backupsItem.urlParam && styles.color} />
                </ListItem>
              </NavLinkStyled>
            }
            {role === 'admin' &&
							<>
								<ListItem button onClick={() => setOpenParam(!openParam)}>
									<ListItemIcon icon={<Settings fontSize={styles.icon.size} />} />
									<ListItemText label={i18n.t('render.listLabel4')} />
									{openParam ? <ExpandLess fontSize={styles.icon.size} /> : <ExpandMore fontSize={styles.icon.size} />}
								</ListItem>
								<Collapse in={openParam} timeout="auto" unmountOnExit>
									<List component="div">
										{
											objListItems.filter(key => (key.type === 'params' || key.type === 'params-title') && (key.roles.indexOf(role) > -1 || role === 'admin') && (!key.featureFlag || featureFlags.includes(key.featureFlag)) ).map(key => {
												return key.type === 'params' ?
													(<NavLinkStyled to={{ pathname: '/' + key.urlParam }} key={key.label}>
														<ListItem
															style={{ backgroundColor: selected === key.urlParam && 'rgba(0,0,0,.05)' }}
															button
															dense
															onClick={() => selectItem(key.urlParam)}
														>
															<ListItemIcon icon={<></>} />
															<ListItemText
																label={key.label}
																color={selected === key.urlParam && styles.color} />
														</ListItem>
													</NavLinkStyled>) :
													<div
														key={key.label}
														style={{
															color: 'grey',
															margin: '10px 0 5px 30px',
														}}
													>
														{key.label}
													</div>
											})
										}
									</List>
								</Collapse>
							</>
            }
          </>
        }
      </List>
      <>
        <Divider />
        <List subheader={<ListSubheader component="div" id="nested-list-subheader1" style={{ backgroundColor: 'white' }}>{<span style={styles.header}>{i18n.t('render.listLabel3')}</span>}</ListSubheader>}>
					{objListItems.filter(key => key.type === 'area4' && (key.roles.indexOf(role) > -1 || role === 'admin') && (!key.tenantFeatureFlag || checkTenantFeatureFlag(key.tenantFeatureFlag, tenantFeatureFlags))).map((key, ind) => (
						<NavLinkStyled to={"/" + key.urlParam} exact={ind === 0} key={key.label}>
              <ListItem
                style={{ backgroundColor: selected === key.urlParam && 'rgba(0,0,0,.05)' }}
                button
                onClick={() => selectItem(key.urlParam)}>
                <ListItemIcon icon={key.icon} color={selected === key.urlParam && styles.color} />
                <ListItemText label={key.label} color={selected === key.urlParam && styles.color} />
              </ListItem>
            </NavLinkStyled>
            ))}
        </List>
      </>
      <Divider />
      { role === 'admin' && <List subheader={<ListSubheader component="div" id="nested-list-subheader1" style={{ backgroundColor: 'white' }}>{<span style={styles.header}>{i18n.t('render.listLabel5')}</span>}</ListSubheader>}>
					{objListItems.filter(key => key.type === 'system' && (key.roles.indexOf(role) > -1 || role === 'admin') && (!key.tenantFeatureFlag || checkTenantFeatureFlag(key.tenantFeatureFlag, tenantFeatureFlags))).map((key, ind) => (
						<NavLinkStyled to={"/" + key.urlParam} exact={ind === 0} key={key.label}>
              <ListItem
                style={{ backgroundColor: selected === key.urlParam && 'rgba(0,0,0,.05)' }}
                button
                onClick={() => selectItem(key.urlParam)}>
                <ListItemIcon icon={key.icon} color={selected === key.urlParam && styles.color} />
                <ListItemText label={key.label} color={selected === key.urlParam && styles.color} />
              </ListItem>
            </NavLinkStyled>
            ))}
        </List>}
    </>
  );
}

export default ListItems;
